import React from "react";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";
import API from "../API";
import { Link } from "react-router-dom";

const PAGE_SIZE_OPTIONS = [20, 50, 100];
const STATUS_OPTIONS = [
  "stock_pending",
  "stock_arrived",
  "order_created",
  "delivered",
  "cancelled",
];
const STATUS_STYLES = {
  stock_pending: {
    backgroundColor: "#F59E0B",
    color: "#FFFFFF",
  },
  stock_arrived: {
    backgroundColor: "#0EA5E9",
    color: "#FFFFFF",
  },
  order_created: {
    backgroundColor: "#5654E8",
    color: "#FFFFFF",
  },
  delivered: {
    backgroundColor: "#10B981",
    color: "#FFFFFF",
  },
  cancelled: {
    backgroundColor: "#EF4444",
    color: "#FFFFFF",
  },
};

const formatDate = (value) => {
  if (!value) return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return date.toLocaleString("tr-TR");
};

const getShortId = (value) =>
  value ? value.substring(Math.max(value.length - 6, 0)).toUpperCase() : "-";

const getStatusLabel = (value) => {
  if (!value) return "Beklemede";
  if (value === "stock_pending") return "Stok Bekliyor";
  if (value === "stock_arrived") return "Stok Geldi";
  if (value === "order_created") return "Sipariş Oluşturuldu";
  if (value === "delivered") return "Teslim Edildi";
  if (value === "cancelled") return "İptal Edildi";

  return value
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

const getContactLabel = (row) => row.phone || row.email || "-";

export default class PendingOrdersScreen extends React.Component {
  constructor() {
    super();

    this.state = {
      rows: [],
      stores: [],
      storeLoadError: "",
      loading: false,
      page: 0,
      pageSize: 20,
      total: 0,
      filters: {
        search: "",
        status: "",
        store_reference_id: "",
      },
      draftFilters: {
        search: "",
        status: "",
        store_reference_id: "",
      },
    };
  }

  componentDidMount() {
    this.getRequests();
    API.fetch("jysk/context", {})
      .then((data) => {
        if (data.error)
          throw new Error(data.message || "Mağazalar yüklenemedi.");
        this.setState({ stores: data.stores || [] });
      })
      .catch((error) => this.setState({ storeLoadError: error.message }));
  }

  getRequests(page = this.state.page, pageSize = this.state.pageSize) {
    this.setState({ loading: true });

    const { filters } = this.state;
    const body = {
      page: page + 1,
      limit: pageSize,
    };

    if (filters.search.trim()) body.search = filters.search.trim();
    if (filters.status.trim()) body.status = filters.status.trim();
    if (filters.store_reference_id.trim()) {
      body.store_reference_id = filters.store_reference_id.trim();
    }

    API.fetchClient("panel/getorderrequests", body)
      .then((response) => {
        const rows = (response.data || []).map((item) => ({
          ...item,
          id: item._id,
        }));

        this.setState({
          rows,
          total: response.pagination?.total || rows.length,
          page: (response.pagination?.page || 1) - 1,
          pageSize: response.pagination?.limit || pageSize,
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  applyFilters() {
    this.setState(
      (prevState) => ({
        page: 0,
        filters: { ...prevState.draftFilters },
      }),
      () => this.getRequests(0, this.state.pageSize),
    );
  }

  resetFilters() {
    this.setState(
      {
        page: 0,
        filters: {
          search: "",
          status: "",
          store_reference_id: "",
        },
        draftFilters: {
          search: "",
          status: "",
          store_reference_id: "",
        },
      },
      () => this.getRequests(0, this.state.pageSize),
    );
  }

  render() {
    const { rows, loading, page, pageSize, total, draftFilters } = this.state;

    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 24,
            gap: 16,
            flexWrap: "wrap",
          }}
        >
          <div>
            <Typography variant="h4" style={{ marginBottom: 8 }}>
              Bekleyen Siparişler
            </Typography>
            <Typography style={{ color: "rgb(101, 116, 139)" }}>
              Panelden aksiyon gerektiren sipariş taleplerini buradan takip
              edebilirsiniz.
            </Typography>
          </div>

          <Button variant="outlined" onClick={() => this.getRequests()}>
            Yenile
          </Button>
        </div>

        <Badge style={{ padding: 0, overflow: "hidden" }}>
          <div
            style={{
              padding: 20,
              paddingLeft: 24,
              paddingRight: 24,
              borderBottom: "1px solid #E6E8F0",
            }}
          >
            <Typography variant="h6" style={{ marginBottom: 16 }}>
              Bekleyen Siparişler
            </Typography>
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "minmax(240px, 1.4fr) repeat(3, minmax(160px, 1fr)) auto",
                gap: 12,
                alignItems: "center",
              }}
            >
              <TextField
                size="small"
                label="Arama"
                value={draftFilters.search}
                onChange={(e) =>
                  this.setState({
                    draftFilters: {
                      ...draftFilters,
                      search: e.target.value,
                    },
                  })
                }
                placeholder="Ad, e-posta veya telefon"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#94A3B8", fontSize: 18 }} />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                select
                size="small"
                label="Durum"
                value={draftFilters.status}
                onChange={(e) =>
                  this.setState({
                    draftFilters: {
                      ...draftFilters,
                      status: e.target.value,
                    },
                  })
                }
              >
                <MenuItem value="">Tümü</MenuItem>
                {STATUS_OPTIONS.map((status) => (
                  <MenuItem key={status} value={status}>
                    {getStatusLabel(status)}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                size="small"
                select
                label="Mağaza"
                error={!!this.state.storeLoadError}
                helperText={this.state.storeLoadError}
                value={draftFilters.store_reference_id}
                onChange={(e) =>
                  this.setState({
                    draftFilters: {
                      ...draftFilters,
                      store_reference_id: e.target.value,
                    },
                  })
                }
              >
                <MenuItem value="">Tüm mağazalar</MenuItem>
                {this.state.stores.map((store) => (
                  <MenuItem key={store.storeId} value={store.storeId}>
                    {store.label} · {store.storeId}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                size="small"
                label="Sayfa başına kayıt"
                value={pageSize}
                onChange={(e) => {
                  const nextPageSize = Number(e.target.value);
                  this.setState({ pageSize: nextPageSize, page: 0 }, () =>
                    this.getRequests(0, nextPageSize),
                  );
                }}
              >
                {PAGE_SIZE_OPTIONS.map((size) => (
                  <MenuItem key={size} value={size}>
                    {size}
                  </MenuItem>
                ))}
              </TextField>
              <div
                style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}
              >
                <Button variant="contained" onClick={() => this.applyFilters()}>
                  Uygula
                </Button>
                <Button variant="outlined" onClick={() => this.resetFilters()}>
                  Temizle
                </Button>
              </div>
            </div>
          </div>

          <DataGrid
            autoHeight
            rows={rows}
            loading={loading}
            rowCount={total}
            pagination
            paginationMode="server"
            checkboxSelection
            pageSizeOptions={PAGE_SIZE_OPTIONS}
            paginationModel={{ page, pageSize }}
            onPaginationModelChange={(model) => {
              if (model.pageSize !== pageSize) {
                this.setState(
                  { pageSize: model.pageSize, page: model.page },
                  () => this.getRequests(model.page, model.pageSize),
                );
                return;
              }

              this.setState({ page: model.page }, () =>
                this.getRequests(model.page, model.pageSize),
              );
            }}
            disableRowSelectionOnClick
            slotProps={{
              pagination: { showFirstButton: true, showLastButton: true },
            }}
            columns={[
              {
                field: "_id",
                headerName: "ID",
                flex: 1.25,
                minWidth: 220,
                renderCell: (params) => (
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 10 }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 500,
                        color: "#3154B5",
                        textDecoration: "none",
                      }}
                    >
                      #{getShortId(params.row._id)}
                    </Typography>
                    <div
                      style={{
                        backgroundColor: "#24479A",
                        color: "white",
                        borderRadius: 4,
                        padding: "3px 8px",
                        fontSize: 12,
                        fontWeight: 700,
                        lineHeight: 1.2,
                        maxWidth: 90,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {params.row.store_label || "Mağaza"}
                    </div>
                  </div>
                ),
              },
              {
                field: "orderId",
                headerName: "SİPARİŞ ID",
                flex: 1,
                minWidth: 170,
                sortable: false,
                renderCell: (params) =>
                  params.row.orderId ? (
                    <Link
                      to={`/order/${params.row.orderId}`}
                      style={{
                        color: "#5654E8",
                        fontWeight: 600,
                        textDecoration: "none",
                      }}
                      title={params.row.orderId}
                    >
                      #{getShortId(params.row.orderId)}
                    </Link>
                  ) : (
                    <Typography sx={{ color: "#94A3B8" }}>-</Typography>
                  ),
              },
              {
                field: "status",
                headerName: "DURUM",
                flex: 0.95,
                minWidth: 180,
                renderCell: (params) => (
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: 30,
                      width: "fit-content",
                      padding: "0 14px",
                      borderRadius: 999,
                      color: STATUS_STYLES[params.value]?.color || "#FFFFFF",
                      backgroundColor:
                        STATUS_STYLES[params.value]?.backgroundColor ||
                        "#5654E8",
                      fontWeight: 700,
                      boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.08)",
                    }}
                  >
                    <Typography
                      sx={{
                        color: STATUS_STYLES[params.value]?.color || "white",
                        fontWeight: 700,
                        lineHeight: 1,
                        fontSize: 13,
                      }}
                      variant="caption"
                    >
                      {getStatusLabel(params.value)}
                    </Typography>
                  </div>
                ),
              },
              {
                field: "store_reference_id",
                headerName: "MAĞAZA REF.",
                flex: 1,
                minWidth: 180,
                valueGetter: (_, row) => row.store_reference_id || "-",
              },
              {
                field: "full_name",
                headerName: "MÜŞTERİ",
                flex: 1,
                minWidth: 180,
                renderCell: (params) => (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ color: "#1F2937" }}>
                      {params.row.full_name || "-"}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#64748B" }}>
                      {params.row.email || "-"}
                    </Typography>
                  </div>
                ),
              },
              {
                field: "contact",
                headerName: "İLETİŞİM",
                flex: 1,
                minWidth: 180,
                valueGetter: (_, row) => getContactLabel(row),
              },
              {
                field: "createdAt",
                headerName: "OLUŞTURMA TARİHİ",
                flex: 1,
                minWidth: 190,
                valueGetter: (_, row) => formatDate(row.createdAt),
              },
              {
                field: "updatedAt",
                headerName: "GÜNCELLENME",
                flex: 1,
                minWidth: 190,
                valueGetter: (_, row) => formatDate(row.updatedAt),
              },
              {
                field: "detail",
                headerName: "",
                sortable: false,
                filterable: false,
                width: 72,
                align: "center",
                headerAlign: "center",
                renderCell: (params) => (
                  <Link
                    to={{
                      pathname: `/pending-orders/${params.row._id}`,
                      state: { orderRequest: params.row },
                    }}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <IconButton size="small" sx={{ color: "#5654E8" }}>
                      <ArrowForwardIcon />
                    </IconButton>
                  </Link>
                ),
              },
            ]}
            sx={{
              border: "none",
              "& .MuiDataGrid-main": {
                borderRadius: 0,
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#F3F5FA",
                borderRadius: 0,
                borderBottom: "1px solid #EEF1F6",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontSize: 12,
                fontWeight: 700,
                color: "#374151",
              },
              "& .MuiDataGrid-columnSeparator": {
                display: "none",
              },
              "& .MuiDataGrid-cell": {
                borderBottomColor: "#EEF1F6",
                fontSize: 14,
                color: "#374151",
                paddingTop: 4,
                paddingBottom: 4,
              },
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus": {
                outline: "none",
              },
              "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus-within":
                {
                  outline: "none",
                },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#FAFBFE",
              },
              "& .MuiCheckbox-root": {
                color: "#61708C",
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "1px solid #EEF1F6",
                minHeight: 56,
              },
            }}
          />
        </Badge>
      </div>
    );
  }
}

const Badge = (props) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        boxShadow:
          "rgb(100 116 139 / 6%) 0px 1px 1px, rgb(100 116 139 / 10%) 0px 1px 2px",
        borderRadius: 8,
        padding: 24,
        color: "rgb(18, 24, 40)",
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};
